export interface SelectedServer {
  id: string
  name: string
  url: string
}

export interface ServerEntry {
  id: number
  type: 'remote' | 'package'
  displayName: string
  selected: boolean
}

export interface SelectedOrganization {
  id: string
  name: string
}

export const PANEL_IDS = {
  EXTERNAL: 'panel-test-external',
  GITHUB: 'panel-test-github',
} as const

export const SELECTORS = {
  DIALOG: '#create-allowlist-dialog',
  CONTROLLER: '[data-controller="allowlist-dialog"]',
} as const
